export const TRIAL_PAGES_V2B = 'v2b';
